// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.settings-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    font-family: Arial, sans-serif;
    position: relative;
  }
  
  /* Header Section */
  .settings-header {
    display: flex;
    align-items: center;
    padding: 20px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #ddd;
  }
  
  /* Back Button */
  .settings-back-button {
    cursor: pointer;
    color: #007bff;
    font-weight: bold;
    margin-right: 20px;
  }
  
  /* Title */
  .settings-title {
    font-size: 1.5rem;
    margin: 0;
  }
  
  /* Main Content */
  .settings-main-content {
    flex: 1 1;
    padding: 20px;
    overflow-y: auto;
  }
  
  /* Content Box */
  .settings-content {
    padding: 20px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  /* Bottom Navigation Bar */
  .settings-navbar {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #f8f9fa;
    padding: 10px 0;
    border-top: 1px solid #ddd;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  
  /* Navigation Items */
  .settings-nav-item {
    padding: 10px 15px;
    cursor: pointer;
    border-radius: 5px;
    text-align: center;
    transition: background-color 0.3s ease;
    font-weight: bold;
  }
  
  /* Active Navigation Item */
  .settings-active-nav-item {
    background-color: #007bff;
    color: #fff;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Settings.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA,gBAAgB;EAChB;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,UAAU;EACV;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA,iBAAiB;EACjB;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA,0BAA0B;EAC1B;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA,qBAAqB;EACrB;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;IACtC,iBAAiB;EACnB;;EAEA,2BAA2B;EAC3B;IACE,yBAAyB;IACzB,WAAW;EACb","sourcesContent":["/* Main Container */\n.settings-container {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    font-family: Arial, sans-serif;\n    position: relative;\n  }\n  \n  /* Header Section */\n  .settings-header {\n    display: flex;\n    align-items: center;\n    padding: 20px;\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #ddd;\n  }\n  \n  /* Back Button */\n  .settings-back-button {\n    cursor: pointer;\n    color: #007bff;\n    font-weight: bold;\n    margin-right: 20px;\n  }\n  \n  /* Title */\n  .settings-title {\n    font-size: 1.5rem;\n    margin: 0;\n  }\n  \n  /* Main Content */\n  .settings-main-content {\n    flex: 1;\n    padding: 20px;\n    overflow-y: auto;\n  }\n  \n  /* Content Box */\n  .settings-content {\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* Bottom Navigation Bar */\n  .settings-navbar {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    background-color: #f8f9fa;\n    padding: 10px 0;\n    border-top: 1px solid #ddd;\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n  }\n  \n  /* Navigation Items */\n  .settings-nav-item {\n    padding: 10px 15px;\n    cursor: pointer;\n    border-radius: 5px;\n    text-align: center;\n    transition: background-color 0.3s ease;\n    font-weight: bold;\n  }\n  \n  /* Active Navigation Item */\n  .settings-active-nav-item {\n    background-color: #007bff;\n    color: #fff;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
